import React from 'react';
import { Controller, useFormContext } from 'react-hook-form';
import { DatePicker } from './DatePicker';

export interface FormDatePickerProps {
  name: string;
  label?: string;
  fullWidth?: boolean;
  size?: 'small' | 'medium';
}

export const FormDatePicker: React.FC<FormDatePickerProps> = ({
  name,
  label,
  fullWidth = true,
  size = 'small',
}) => {
  const { control } = useFormContext();

  return (
    <Controller
      name={name}
      control={control}
      render={({ field: { value, onChange }, fieldState: { error } }) => (
        <DatePicker
          label={label}
          value={value}
          onChange={onChange}
          fullWidth={fullWidth}
          size={size}
          slotProps={{
            textField: {
              fullWidth,
              size,
              error: !!error,
              helperText: error?.message,
            },
          }}
        />
      )}
    />
  );
};

export default FormDatePicker;
